// mobile product page gallery
function moveMobileSticky() {
    const mobileSticky = document.getElementById("mobile-sticky");
    const productMain = document.querySelector(".product__main");
    const productOuter = document.querySelector(".product__outer");
    if (window.innerWidth < 750) {
        if (mobileSticky && productMain && productOuter) {
          // Move #mobile-sticky to be a sibling of .product__main
          productOuter.insertBefore(mobileSticky, productMain.nextSibling);
          requestAnimationFrame(() => {
                mobileSticky.style.opacity = "1";
            });
        }
    }
}
window.addEventListener("resize", moveMobileSticky);
window.addEventListener("DOMContentLoaded", moveMobileSticky);
// Product Page - Autoplay Gallery Video When In View
document.addEventListener('DOMContentLoaded', function () {
  const posterButtons = document.querySelectorAll('.deferred-media__poster-button');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const button = entry.target;
        if (!button.classList.contains('autoplay-triggered')) {
          button.click(); // Simulate user interaction
          button.classList.add('autoplay-triggered'); // Prevent repeat
          observer.unobserve(button); // Clean up
        }
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.5 // Trigger when 50% visible (adjust as needed)
  });

  posterButtons.forEach(button => observer.observe(button));
});
